import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Button } from 'react-bootstrap';

/* import Axios library */
import Axios from 'axios';
import { saveAs } from 'file-saver/FileSaver';

import LoaderAnimation from '../shared/loaderAnimation';
//import the static asset URLs var from the config file
import * as RJRTConfigVars from '../../config';


class TextView extends Component {

    constructor(props) {
        
        super(props);

        this.state = {
            fileACC: this.props.match.params.fileACC,
            formBrand: this.props.match.params.formBrand,
            formType: this.props.match.params.formType,
            loading: true
        }

        console.log(this.props.match);
    }

    componentDidMount() {

        //set up basic search parameters
        let postData = {
                search:  `ACC:'${this.state.fileACC}'`,
                count: true,
                queryType: 'full',
                searchMode: 'all',
                top:10
        };
        
        let url = RJRTConfigVars.RJRTSearchURLS[this.state.formBrand][this.state.formType];

        //the loading animation will be playing (due to initial state being set to 'loading')            
        Axios.post(url, postData, {headers: { 'api-key': RJRTConfigVars.RJRTSearchAPIKey, 'accept': 'application/json;odata=verbose', 'Content-Type': 'application/json'}})
        .then((response) => {
            
            this.setState({
                textData: response.data.value[0].FILE_DATA,
                loading:false
            })
            
            // this.setState({
            //     resultData: response.data.value, 
            //     loading: false,
            //     totalDocCount: response.data.value.length
            // });
        });
    }

    handleFileDownload() {
        let file = new Blob([this.state.textData], {type: 'text/plain;charset=utf-8'});
        saveAs(file, `${this.state.fileACC}.txt`);    
    }



    render() {

        const isLoading = this.state.loading;

        if (isLoading) {
            return (<LoaderAnimation loadingText="Loading text..." />);
        } else {
            return(
            <React.Fragment>
                <p align="center"><Button onClick={this.handleFileDownload.bind(this)} bsStyle="primary" bsSize="large">Download text</Button></p>
                <p>
                    {this.state.textData}
                </p>
                <p align="center"><Button onClick={this.handleFileDownload.bind(this)} bsStyle="primary" bsSize="large">Download text</Button></p>
            </React.Fragment>
            )
        }

    }
}

export default withRouter(TextView);


// WEBPACK FOOTER //
// ./src/components/textView/textView.js